// src/screens/PrivacyPage/PrivacyPage.js
import React from "react";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div
      className="container"
      style={{ paddingTop: "100px", paddingBottom: "50px" }}
    >
      <h1 className="text-center mb-4">{t("privacy.title")}</h1>
      <p className="mb-4">{t("privacy.intro")}</p>

      <h4 className="mt-4">{t("privacy.data_collection.title")}</h4>
      <p>{t("privacy.data_collection.details1")}</p>

      <h4 className="mt-4">{t("privacy.data_usage.title")}</h4>
      <p>{t("privacy.data_usage.details1")}</p>
      <p>{t("privacy.data_usage.details2")}</p>

      <h4 className="mt-4">{t("privacy.data_security.title")}</h4>
      <p>{t("privacy.data_security.details1")}</p>
      <p>{t("privacy.data_security.details2")}</p>
    </div>
  );
};

export default PrivacyPolicy;
